import RoleSimpleForm from './RoleSimpleForm'

export default RoleSimpleForm
